import { fetchAuthSession } from "aws-amplify/auth";
import { useCallback } from "react";
import { addTermVersion, createS3Client } from "@/shared/lib/s3";
import type { TermType, TermVersion } from "../types/terms";

export interface RegisterTermResponse {
	versionNumber: number;
	uploadTime: string;
	type: string;
}

/**
 * 利用規約の登録・更新
 */
export const useTerms = () => {
	/**
	 * 新しい利用規約バージョンを登録する（terms.jsonを更新）
	 * @param type - 規約タイプ ('app' | 'glicomembers')
	 * @param newVersion - 新しいバージョン情報
	 */
	const registerTermVersion = useCallback(
		async (type: TermType, newVersion: TermVersion): Promise<RegisterTermResponse> => {
			const session = await fetchAuthSession();
			const idToken = session.tokens?.idToken?.toString();

			if (!idToken) {
				throw new Error("認証が必要です");
			}

			// S3クライアントを作成
			const s3Client = await createS3Client(idToken);

			// 新しいバージョンを追加
			try {
				await addTermVersion(s3Client, type, newVersion);
			} catch (error) {
				if (error instanceof Error && error.message.includes("already exists")) {
					throw new Error(error.message);
				}
				throw new Error(
					`登録に失敗しました: ${error instanceof Error ? error.message : String(error)}`,
				);
			}

			// バージョン番号を抽出
			const versionNumber = Number.parseInt(newVersion.version.replace(/^v/, ""), 10) || 1;

			return {
				versionNumber,
				uploadTime: new Date().toISOString(),
				type,
			};
		},
		[],
	);

	return {
		registerTermVersion,
	};
};
